import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { getListeProduit } from '../actions'
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Image from 'react-bootstrap/Image'
import ListItemText from '@material-ui/core/ListItemText';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { imagesRepo } from '../config';






const SearchProd = ({ listeProduit, getListeProduit, handleSelect, produit, initialRef, onEnter = () => { }, viewList = true, autoFocus = true, fullScreen = false }) => {

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const [search, setSearch] = useState(fullScreen && initialRef ? initialRef : '')
    const [matchesProduct, setMatchesProduct] = useState([])
    const [collapsed, setCollapsed] = useState(false)

    useEffect(() => {
        getListeProduit()
    }, [getListeProduit]);

    // fullScreen : pré-remplir avec initialRef
    useEffect(() => {
        if (fullScreen && initialRef && listeProduit) {
            const searchText = initialRef.substring(0, 4).toLowerCase()
            const filtered = Object.values(listeProduit).filter(r => r.ref.toString().toLowerCase().indexOf(searchText) > -1)
            setSearch(initialRef)
            setMatchesProduct(filtered)
            setCollapsed(false)
        }
    }, [fullScreen, initialRef, listeProduit]);

    useEffect(() => {
        if (!fullScreen && produit) {
            setSearch(produit.ref)
            if (!isMobile) {
                if (listeProduit && produit.ref) {
                    const searchText = produit.ref.substring(0, 4).toLowerCase()
                    const filtered = Object.values(listeProduit).filter(r => r.ref.toString().toLowerCase().indexOf(searchText) > -1)
                    setMatchesProduct(filtered)
                }
            }
        } else if (!fullScreen && !produit) {
            setSearch('')
        }
    }, [listeProduit, produit, handleSelect, isMobile, fullScreen]);



    const handleSearch = (e) => {
        const search = e.target.value
        if (isMobile || fullScreen) setCollapsed(false)
        searchProduit(search, !fullScreen)
    }

    const handleInputClick = () => {
        if (fullScreen && matchesProduct.length > 0) {
            setCollapsed(false)
        }
        onEnter()
    }
    const searchProduit = (search, autoSelect = true) => {
        const searchText = search.substring(0, 4).toLowerCase()
        let matchesProduct = []
        if (search.length >= 3 || search === 'sav') matchesProduct = Object.values(listeProduit).filter(r => r.ref.toString().toLowerCase().indexOf(searchText) > -1)
        setMatchesProduct(matchesProduct)
        setSearch(search)

        if ((search.length === 4 || search.toLowerCase() === 'sav') && matchesProduct.length !== 0 && autoSelect) handleSelect(matchesProduct[0])
    }
    const handleEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            search !== '' && matchesProduct.length !== 0 && handleSelect(matchesProduct[0]) && setSearch(matchesProduct[0].ref + ' ' + matchesProduct[0].description)
            if (isMobile) setCollapsed(true)
            onEnter()
        }
    }
    const createListe = (produit) => {
        if (search.length >= 3 || search.toLowerCase() === 'sav') {
            return (
                Object.values(produit)
                    .map((produit) =>
                        <ListItem style={{ width: '100%' }} button key={produit.id_centre} onClick={() => {
                            handleSelect(produit, false)
                            setSearch(produit.ref + ' ' + produit.description)
                            if (isMobile) setCollapsed(true)
                        }}>

                            <ListItemIcon><Image src={`${imagesRepo}thumbs.php?src=${produit.img_centre !== 'no_pic.jpg' ? produit.img_centre : produit.image}&size=60`} style={{ width: 60, height: 60 }} rounded /></ListItemIcon>
                            <ListItemText primary={produit.description + ' - ' + produit.total3 + ' €'} />
                        </ListItem>
                    )
            )
        }
        else return null

    }

    const showList = fullScreen
        ? (!collapsed && matchesProduct.length !== 0 && listeProduit && search.length >= 3)
        : isMobile
            ? (!collapsed && matchesProduct.length !== 0 && listeProduit && search.length >= 3 && viewList)
            : (matchesProduct.length !== 0 && listeProduit && search.length > 3 && viewList)

    const listStyle = fullScreen
        ? { flex: 1, overflowY: 'auto', backgroundColor: '#fff' }
        : isMobile
            ? { maxHeight: 300, overflowY: 'auto', backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: 4, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', position: 'relative', zIndex: 10 }
            : {}

    // Mode plein écran mobile
    if (fullScreen) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <TextField
                    fullWidth
                    label="Tapez la référence (chiffres)"
                    variant="outlined"
                    value={search}
                    autoFocus
                    onClick={handleInputClick}
                    onChange={handleSearch}
                    onKeyPress={handleEnter}
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', style: { fontSize: 22, padding: '16px 14px' } }}
                    InputLabelProps={{ style: { fontSize: 18 } }}
                    style={{ marginBottom: 8 }}
                />
                {showList && (
                    <List style={listStyle}>
                        {Object.values(matchesProduct).map((p) => (
                            <ListItem
                                button
                                key={p.id_centre}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    handleSelect(p, false)
                                    setSearch(p.ref + ' ' + p.description)
                                    setCollapsed(true)
                                }}
                                style={{ padding: '12px 8px', borderBottom: '1px solid #f0f0f0' }}
                            >
                                <ListItemIcon>
                                    <Image
                                        src={`${imagesRepo}thumbs.php?src=${p.img_centre !== 'no_pic.jpg' ? p.img_centre : p.image}&size=80`}
                                        style={{ width: 70, height: 70, borderRadius: 6 }}
                                        rounded
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={p.ref + ' - ' + p.description}
                                    secondary={p.total3 + ' €'}
                                    primaryTypographyProps={{ style: { fontSize: 16, fontWeight: 500 } }}
                                    secondaryTypographyProps={{ style: { fontSize: 15, color: '#1976d2', fontWeight: 600 } }}
                                />
                            </ListItem>
                        ))}
                    </List>
                )}
                {search.length > 0 && search.length < 3 && (
                    <div style={{ textAlign: 'center', color: '#999', marginTop: 20, fontSize: 15 }}>
                        Tapez au moins 3 chiffres...
                    </div>
                )}
                {search.length >= 3 && matchesProduct.length === 0 && (
                    <div style={{ textAlign: 'center', color: '#999', marginTop: 20, fontSize: 15 }}>
                        Aucun produit trouvé
                    </div>
                )}
            </div>
        )
    }

    return (
        <div  >
            <TextField fullWidth style={{ paddingTop: 3 }} label="Rechercher Produit" variant="outlined"

                value={search}
                autoFocus={autoFocus}
                onClick={onEnter}
                autoComplete="true"
                onChange={handleSearch}
                onKeyPress={handleEnter}
            />

            {showList &&
                <List style={listStyle}>
                    {createListe(matchesProduct)}
                </List>
            }
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        listeProduit: state.produit.listeProduit,
    }
}
const mapDispatchToProps = {
    getListeProduit,
}
export default connect(mapStateToProps, mapDispatchToProps)(SearchProd)
